"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_DISABLED = exports.CLASS_CLOSED = exports.CLASS_OPEN = exports.CLASS_HIDDEN = exports.CLASS_SCROLL = exports.CLASS_ACTIVE = exports.CLASS_FILLED = void 0;
exports.CLASS_FILLED = 'filled';
exports.CLASS_ACTIVE = 'active';
exports.CLASS_SCROLL = 'scroll';
exports.CLASS_HIDDEN = 'hidden';
exports.CLASS_OPEN = 'open';
exports.CLASS_CLOSED = 'closed';
exports.CLASS_DISABLED = 'disabled';
